import React, { useState, FC, KeyboardEvent, ChangeEvent } from 'react';
import { Input, Alert, Space, Tag, Select } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import { Icon } from 'Components';
const { Option } = Select;

const mockRecipients = [
  'acolque@marriott.com',
  'acolque',
  'admin1@testmail.com',
  'admin2@testmail.com',
  'admin3@testmail.com',
  'admin4@testmail.com',
  'admin5@testmail.com',
];

type TestConfigurationProps = {
  onBack: () => void;
  onNext: (emails: string[]) => void;
  setErrorMessage: (message: string) => void
};

const CloseIcon = () => (
  <Icon type="campaignStepClose" />
);

const tagRender = (props: any) => {
  const { label, closable, onClose } = props;

  return (
    <span className="ml-chip">
      <span className="ml-chip-text">{label}</span>

      {closable && (
        <span
          className="ml-chip-close"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </span>
      )}
    </span>
  );
};

const TestConfiguration = ({ onBack, onNext }: TestConfigurationProps) => {
  const [recipients, setRecipients] = useState<string[]>([]);
  const [emailError, setEmailError] = useState<string | null>(null);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const hasInvalidEmail = (emails: string[]) =>
    emails.some(email => !emailRegex.test(email));

  const handleChange = (values: string[]) => {
    setRecipients(values);
    if (hasInvalidEmail(values)) {
      setEmailError("Enter a valid email address");
    } else {
      setEmailError(null);
    }
  };

  return (
    <div className='d-flex justify-center align-center flex-column'>
      <div className="test-configuration-container">
        <div className="test-config-header">
          <h2 className="test-config-title">Test Configuration</h2>
          <p className="test-config-subtitle">
            Select users to receive a test phishing email to verify setup before the full campaign
          </p>
        </div>

        <div className="test-config-form">
          <div className="form-label-group">
            <span className="form-label">
              Test recipients
              <span className="required-asterisk">*</span>
            </span>
          </div>

          <div className="email-input-wrapper">
            <Select
              mode="tags"
              size="large"
              value={recipients}
              onChange={handleChange}
              placeholder="Enter one or more email addresses"
              tokenSeparators={[',', ' ']}
              className="ml-input-chip"
              style={{ width: '100%' }}
              tagRender={tagRender}
            >
              {mockRecipients.map((email) => (
                <Option key={email} value={email}>
                  {email}
                </Option>
              ))}
            </Select>{emailError && (
              <div className="ml-input-help-text">
                {emailError}
              </div>
            )}
          </div>
          <Alert
            message="Test emails are sent within a few minutes after the test campaign is started."
            type="info"
            icon={<Icon type="campaignInfo" />}
            className="test-info-alert"
            showIcon
          />
        </div>
      </div>
      <div className="d-flex gap-12 mtx-24 justify-between test-configuration-steps">

        {onBack && (
          <button onClick={onBack} className="cs-launch-back-button">
            <Icon type="previousPagination" />
            Back
          </button>
        )}
        <button onClick={() => onNext(recipients)} disabled={(recipients.length === 0 || !!emailError)} style={{ background: (recipients.length === 0 || !!emailError) ? "#EAEAEB" : "#006ca3", color: (recipients.length === 0 || !!emailError) ? "#4A4D4D" : "#fff" }} className="cs-launch-next-step2-button">
          Next {(recipients.length === 0 || !!emailError) ? <Icon type="campaignPaginationNextBlur" /> : <Icon type="campaignPaginationNext" />}
        </button>
      </div>
    </div>
  );
};

export default TestConfiguration;